import { api } from './api';
import type { Organisatie } from '@types';

// ============================================
// Organisatie API Functions
// ============================================

/**
 * Haal alle organisaties op
 * @returns Array van organisaties
 */
export const getOrganisaties = async (): Promise<Organisatie[]> => {
  const response = await api.get<Organisatie[]>('/organisaties');
  return response.data;
};
